export class CustomRegister {
	customRegisterId: number;
	customRegisterName: string;
	locationId: number;
	isActive: boolean;
	isDeleted: boolean;
	createdOn: Date;
	createdBy: number;
	updatedOn: Date;
	updatedBy: number;
	thermalId: number;
	emailId: number;
	emailConfigId: number;
	allowTips: boolean;
	advancedThermalId: number;
	departmentId: number;
	siteId: number;
	disableReceipt: boolean;
	allowPriceOverride: boolean;
	showAuthOnly: boolean;
	isEnableKiosk: boolean;
	kioskEnabled : boolean;
	enableTicketPrint : boolean;
	disableBarCodeScan : boolean;
	disableProductPurchase : boolean;
	isDisablePaperReceipt: boolean;
	landingPageImage: string;
	thankYouPageText: string;
	callNameLabel: string;
	inActivityTimerInSec: number;
	timerAfterTransactionInSec: number;
	primaryColor: string;
	enableSignatureCapture: boolean;
	imagePath: string;
	showEmail: boolean;
	enableCreditSwipe : boolean;
	enableManualCredit : boolean;
	hideInfoStep : boolean;
	removeOnScreenKeyboard : boolean;
	allowCashPaymentAtCounter : boolean;
	waiverId : number;
	waiverRequired : boolean;
	recaptcha_Key: any;
	recaptcha_Keyv2: any;
	gatewayProcessor: any;
	tenantName: any;
	enableStripeTerminalReader: boolean;
	useStripeSimulatedReader: boolean;
	stripeTerminalUrl: string;
	defaultStripeReaderId: string;
}
